// 管理和维护一些复用功能的自定义 js

// 阻止默认事件的辅助函数
function preventDefault(e) {
  e.preventDefault();
}

// 禁用页面滚动的函数
function disableScroll() {
  document.documentElement.style.overflow = 'hidden';
  document.body.style.overflow = 'hidden';

  window.addEventListener('wheel', preventDefault, { passive: false });
  window.addEventListener('touchmove', preventDefault, { passive: false });

  window.addEventListener('resize', () => {
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  });
}

// 将函数挂载到 window 对象上，使其全局可用
window.preventDefault = preventDefault;
window.disableScroll = disableScroll;





/*
// 2025----chrismas----雪花 
let snowflakeCanvas = null;
let snowflakeCtx = null;
let cursorCanvas = null;
let cursorCtx = null;
let globalTime = 0;

// 雪花粒子类
class SnowParticle {
  constructor(x, y, explosive = false) {
    this.x = x;
    this.y = y;
    this.radius = explosive ? (Math.random() * 4 + 1) : (Math.random() * 1.5 + 0.5);
    this.life = explosive ? 30 + Math.random() * 20 : 20 + Math.random() * 10;
    this.opacity = 1;
    this.vx = (Math.random() - 0.5) * (explosive ? 6 : 1);
    this.vy = explosive ? (Math.random() - 0.5) * 6 : 0.5 + Math.random() * 1.5;
    this.gravity = explosive ? 0.12 : 0.02;
  }
  
  update() {
    this.x += this.vx;
    this.y += this.vy;
    this.vy += this.gravity;
    this.life--;
    if (this.life < 20) this.opacity -= 0.03;
  }
  
  draw(ctx) {
    const g = ctx.createRadialGradient(this.x, this.y, this.radius * 0.2, this.x, this.y, this.radius);
    g.addColorStop(0, `rgba(255,255,255,${this.opacity})`);
    g.addColorStop(0.5, `rgba(220,240,255,${this.opacity * 0.9})`);
    g.addColorStop(1, `rgba(255,255,255,0)`);
    ctx.fillStyle = g;
    ctx.beginPath();
    ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
    ctx.fill();
  }
}

// 雪花类
class Snowflake {
  constructor(canvas) {
    this.canvas = canvas;
    this.reset();
    this.y = Math.random() * canvas.height;
  }
  
  reset() {
    this.x = Math.random() * this.canvas.width;
    this.y = -20;
    this.size = 3 + Math.random() * 5;
    this.speedY = 0.3 + Math.random() * 0.7;
    this.speedX = (Math.random() - 0.5) * 0.5;
    this.opacity = 0.7 + Math.random() * 0.3;
    this.wobble = Math.random() * Math.PI * 2;
    this.wobbleSpeed = 0.01 + Math.random() * 0.02;
    this.fadeStart = this.canvas.height * 0.5;
    this.fadeEnd = this.canvas.height * 0.7;
    this.fuzziness = 0.6 + Math.random() * 0.4;
  }
  
  update() {
    this.y += this.speedY;
    this.wobble += this.wobbleSpeed;
    this.x += Math.sin(this.wobble) * 0.5 + this.speedX;
    
    if (this.y > this.fadeStart) {
      const fadeProgress = (this.y - this.fadeStart) / (this.fadeEnd - this.fadeStart);
      this.opacity = (0.7 + Math.random() * 0.3) * (1 - fadeProgress);
    }
    
    if (this.y > this.fadeEnd || this.x < -20 || this.x > this.canvas.width + 20) {
      this.reset();
    }
  }
  
  draw(ctx) {
    const gradient = ctx.createRadialGradient(this.x, this.y, 0, this.x, this.y, this.size);
    gradient.addColorStop(0, `rgba(255, 255, 255, ${this.opacity})`);
    gradient.addColorStop(this.fuzziness * 0.3, `rgba(240, 248, 255, ${this.opacity * 0.8})`);
    gradient.addColorStop(this.fuzziness * 0.6, `rgba(220, 235, 255, ${this.opacity * 0.4})`);
    gradient.addColorStop(1, `rgba(255, 255, 255, 0)`);
    
    ctx.fillStyle = gradient;
    ctx.beginPath();
    ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
    ctx.fill();
    
    for (let i = 0; i < 3; i++) {
      const offsetX = (Math.random() - 0.5) * this.size;
      const offsetY = (Math.random() - 0.5) * this.size;
      const smallSize = this.size * (0.2 + Math.random() * 0.3);
      
      const smallGradient = ctx.createRadialGradient(
        this.x + offsetX,
        this.y + offsetY,
        0,
        this.x + offsetX,
        this.y + offsetY,
        smallSize,
      );
      smallGradient.addColorStop(0, `rgba(255, 255, 255, ${this.opacity * 0.6})`);
      smallGradient.addColorStop(1, `rgba(255, 255, 255, 0)`);
      
      ctx.fillStyle = smallGradient;
      ctx.beginPath();
      ctx.arc(this.x + offsetX, this.y + offsetY, smallSize, 0, Math.PI * 2);
      ctx.fill();
    }
  }
}

// 全局光标效果变量
let cursorParticles = [];
let cursorX = 0;
let cursorY = 0;

// 光标效果函数
function initCursorEffects() {
  // 创建光标画布
  cursorCanvas = document.createElement('canvas');
  cursorCtx = cursorCanvas.getContext('2d');
  cursorCanvas.id = 'cursor-canvas';
  
  function setCursorCanvasSize() {
    cursorCanvas.width = window.innerWidth;
    cursorCanvas.height = window.innerHeight;
  }
  
  // 设置画布样式
  cursorCanvas.style.position = 'fixed';
  cursorCanvas.style.top = '0';
  cursorCanvas.style.left = '0';
  cursorCanvas.style.width = '100%';
  cursorCanvas.style.height = '100%';
  cursorCanvas.style.pointerEvents = 'none';
  cursorCanvas.style.zIndex = '9999';
  
  document.body.appendChild(cursorCanvas);
  setCursorCanvasSize();
  
  function addCursorParticle(x, y) {
    cursorParticles.push(new SnowParticle(x, y));
  }
  
  function explodeCursor(x, y) {
    for (let i = 0; i < 10; i++) cursorParticles.push(new SnowParticle(x, y, true));
  }
  
  function drawCursor(ctx) {
    const baseRadius = 8 + Math.sin(globalTime * 0.1) * 3.6;
    const highlightX = cursorX - baseRadius * 0.4;
    const highlightY = cursorY - baseRadius * 0.4;
    
    // 外层柔光
    const glow = ctx.createRadialGradient(cursorX, cursorY, 0, cursorX, cursorY, baseRadius * 2.5);
    glow.addColorStop(0, 'rgba(255,255,255,0.25)');
    glow.addColorStop(1, 'rgba(255,255,255,0)');
    ctx.fillStyle = glow;
    ctx.beginPath();
    ctx.arc(cursorX, cursorY, baseRadius * 2.5, 0, Math.PI * 2);
    ctx.fill();
    
    // 主体球体
    const g = ctx.createRadialGradient(cursorX, cursorY, baseRadius * 0.3, cursorX, cursorY, baseRadius);
    g.addColorStop(0, 'rgba(255,255,255,1)');
    g.addColorStop(0.4, 'rgba(220,240,255,0.9)');
    g.addColorStop(1, 'rgba(180,210,255,0.0)');
    ctx.fillStyle = g;
    ctx.beginPath();
    ctx.arc(cursorX, cursorY, baseRadius, 0, Math.PI * 2);
    ctx.fill();
    
    // 高光
    const h = ctx.createRadialGradient(highlightX, highlightY, 0, highlightX, highlightY, baseRadius * 0.6);
    h.addColorStop(0, 'rgba(255,255,255,0.9)');
    h.addColorStop(1, 'rgba(255,255,255,0)');
    ctx.fillStyle = h;
    ctx.beginPath();
    ctx.arc(highlightX, highlightY, baseRadius * 0.6, 0, Math.PI * 2);
    ctx.fill();
    
    // 微闪
    const pulse = 0.5 + 0.5 * Math.sin(globalTime * 0.15);
    ctx.fillStyle = `rgba(255,255,255,${0.2 * pulse})`;
    ctx.beginPath();
    ctx.arc(cursorX, cursorY, baseRadius * 1.4, 0, Math.PI * 2);
    ctx.fill();
  }
  
  function updateCursorEffects() {
    globalTime++;
    cursorCtx.clearRect(0, 0, cursorCanvas.width, cursorCanvas.height);
    
    // 更新和绘制粒子
    for (let i = cursorParticles.length - 1; i >= 0; i--) {
      const p = cursorParticles[i];
      p.update();
      p.draw(cursorCtx);
      if (p.opacity <= 0) cursorParticles.splice(i, 1);
    }
    
    drawCursor(cursorCtx);
    requestAnimationFrame(updateCursorEffects);
  }
  
  function onMouseMove(e) {
    cursorX = e.clientX;
    cursorY = e.clientY;
    addCursorParticle(cursorX, cursorY);
  }
  
  function onClick(e) {
    explodeCursor(e.clientX, e.clientY);
  }
  
  window.addEventListener('mousemove', onMouseMove);
  window.addEventListener('click', onClick);
  window.addEventListener('resize', setCursorCanvasSize);
  
  updateCursorEffects();
}

// 雪花效果函数
function initSnowflakeEffects(container) {
  if (!container) return;
  
  // 创建雪花画布
  snowflakeCanvas = document.createElement('canvas');
  snowflakeCtx = snowflakeCanvas.getContext('2d');
  snowflakeCanvas.className = 'snowflake-canvas';
  
  function setSnowflakeCanvasSize() {
    const rect = container.getBoundingClientRect();
    snowflakeCanvas.width = rect.width;
    snowflakeCanvas.height = rect.height;
    snowflakeCanvas.style.width = rect.width + 'px';
    snowflakeCanvas.style.height = rect.height + 'px';
  }
  
  // 设置画布样式
  snowflakeCanvas.style.position = 'absolute';
  snowflakeCanvas.style.top = '0';
  snowflakeCanvas.style.left = '0';
  snowflakeCanvas.style.pointerEvents = 'none';
  snowflakeCanvas.style.zIndex = '1';
  
  container.style.position = 'relative';
  container.appendChild(snowflakeCanvas);
  setSnowflakeCanvasSize();
  
  const snowflakes = [];
  
  function initSnowflakes() {
    const snowflakeCount = Math.floor(snowflakeCanvas.width / 40);
    for (let i = 0; i < snowflakeCount; i++) {
      snowflakes.push(new Snowflake(snowflakeCanvas));
    }
  }
  
  function updateSnowflakeEffects() {
    snowflakeCtx.clearRect(0, 0, snowflakeCanvas.width, snowflakeCanvas.height);
    
    // 更新和绘制雪花
    for (let i = snowflakes.length - 1; i >= 0; i--) {
      const snowflake = snowflakes[i];
      snowflake.update();
      snowflake.draw(snowflakeCtx);
    }
    
    requestAnimationFrame(updateSnowflakeEffects);
  }
  
  function onResize() {
    setSnowflakeCanvasSize();
    const targetCount = Math.floor(snowflakeCanvas.width / 40);
    while (snowflakes.length < targetCount) {
      snowflakes.push(new Snowflake(snowflakeCanvas));
    }
    while (snowflakes.length > targetCount) {
      snowflakes.pop();
    }
  }
  
  window.addEventListener('resize', onResize);
  
  initSnowflakes();
  updateSnowflakeEffects();
}

// 初始化函数
function initializeEffects() {
  // 初始化全局光标效果
  initCursorEffects();
  
  // 为banner添加雪花效果
  const bannerWrapper = document.querySelector('.banner-wrapper');
  if (bannerWrapper) {
    initSnowflakeEffects(bannerWrapper);
  }
}

// 导出函数供外部使用
window.initCursorEffects = initCursorEffects;
window.initSnowflakeEffects = initSnowflakeEffects;
window.initializeEffects = initializeEffects;
*/


